import React from 'react'
import { RelatedProductsHeaderRoot } from './RelatedProductsHeader.styles'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import useTranslation from 'next-translate/useTranslation'
import { StampWrapper } from '../../../../../MealPlan/screens/ProductPage/ProductPage.styles'
import badge from '../../../../../../../public/assets/badge-rightest.svg'
import Image from 'next/image'

export const RelatedProductsHeader = () => {
  const { t } = useTranslation()

  return (
    <RelatedProductsHeaderRoot>
      <Stack direction="column">
        <Text
          as="h3"
          size={{ '@initial': 'h4', '@bp2': 'h3' }}
          weight="bold"
          color="tertiary-900"
          align="center"
        >
          {t('e-commerce:detail.other-products')}
        </Text>
        <StampWrapper>
          <Image src={badge} alt="" />
        </StampWrapper>
      </Stack>
    </RelatedProductsHeaderRoot>
  )
}

RelatedProductsHeader.displayName = 'RelatedProductsHeader'
